document.addEventListener("DOMContentLoaded", function () {
    // Cache DOM el
    const brandListsContainer = document.querySelector(".brandlists-container");
    const searchInput = document.querySelector(
        'input[placeholder="Search for a brand"]'
    );
    const brandLists = brandListsContainer.querySelectorAll("ul[data-letter]");

    // Debounce function
    function debounce(func, wait) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    // Filter brands
    const filterBrands = debounce(function (searchTerm) {
        searchTerm = searchTerm.toLowerCase();

        brandLists.forEach((ul) => {
            const brands = ul.querySelectorAll("li");
            let visibleBrands = 0;

            brands.forEach((li) => {
                const brandName = li.textContent.trim().toLowerCase();
                if (brandName.includes(searchTerm)) {
                    li.style.display = "";
                    visibleBrands++;
                } else {
                    li.style.display = "none";
                }
            });

            ul.style.display = visibleBrands > 0 ? "" : "none";
        });
    }, 200);

    // Search input handler
    searchInput.addEventListener("input", function () {
        const minSearchLength = 2;
        if (this.value.length >= minSearchLength) {
            filterBrands(this.value);
        } else {
            filterBrands("");
        }
    });
});
